<microsec-loading-overlay [isLoading]="isLoading()">
  <microsec-card [isBordered]="false">
    <div class="p-4">
      <div class="mb-5">Use the credentials below to login to the Threat Intelligence Platform.</div>
      <microsec-form-builder #fb [isPage]="true" [fields]="fields()" [shouldShowActionButtons]="false" />
    </div>
    <!-- Buttons - Cancel and Proceed -->
    <div class="flex flex-row w-full justify-end">
      <p-button class="mr-2" type="button" severity="secondary" label="Cancel" (onClick)="onCancel()" />
      <p-button type="button" severity="primary" label="Open in new tab" (onClick)="onProceed()" />
    </div>
  </microsec-card>
</microsec-loading-overlay>
